import React, { useState } from 'react'
import { styled } from "@mui/material/styles";
import { makeStyles, Button, Grid, Snackbar } from "@material-ui/core";
import Typography from "@mui/material/Typography";
import MuiAlert from '@mui/material/Alert';
import SvgIcon from '@mui/material/SvgIcon';

import settingSvg from '../../assets/svg/setting.svg'
import eyeSvg from '../../assets/svg/eye.svg'
import translatorSvg from '../../assets/svg/translator.svg'
import collectSvg from '../../assets/svg/collect.svg'
import cancelCollectSvg from '../../assets/svg/cancelCollect.svg'
import shareSvg from '../../assets/svg/share.svg'
import downSvg from '../../assets/svg/arrow-down.svg'
import upSvg from '../../assets/svg/arrow-up.svg'

const useStyles = makeStyles({
  card: {
    minHeight: '123px',
    marginBottom: '23px',
    padding: '14px 16px 0',
    background: '#FFFFFF',
    boxShadow: '0px 1px 5px 1px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px'
  },
  timeLineBox: {
    position: 'relative',
    paddingLeft: '30px'
  },
  timeLine: {
    position: 'absolute',
    left: '14px',
    top: '0',
    width: '1px',
    height: '100%',
    background: 'rgba(9, 10, 11, 0.23)',
    '&.clear': {
      top: '6px',
      height: 'calc(100% - 6px)'
    }
  },
  timeLineCircle: {
    position: 'absolute',
    left: '7px',
    top: '6px',
    width: '16px',
    height: '16px',
    background: '#fff',
    border: '2px solid #2BBFB6',
    borderRadius: '50%',
    boxSizing: 'border-box',
    zIndex: '10'
  },
  timeLabel: {
    display: 'inline-block',
    width: '105px',
    height: '28px',
    marginBottom: '12px !important',
    fontSize: '18px',
    color: '#fff',
    lineHeight: '28px',
    borderRadius: '14px',
    textAlign: 'center',
    background: '#2BBFB6'
  },
  titleLine: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  flexCenter: {
    width: '1px',
    display: 'flex',
    alignItems: 'center',
    flex: 1
  },
  status: {
    minWidth: '70px',
    height: '32px',
    padding: '0 8px',
    marginLeft: '40px', 
    background: (medical_file) => {
      if (medical_file.medical_file_law_status == '征求意见稿') {
        return '#FCD600'
      } else if (medical_file.medical_file_law_status == '暂行') {
        return '##FF6100'
      } else {
        return '#A4D322'
      }
    },
    borderRadius: '16px',
    fontSize: '14px',
    textAlign: 'center',
    color: '#fff',
    lineHeight: '32px'
  },
  tag: {
    width: '38px',
    height: '38px',
    marginRight: '12px !important',
    background: (medical_file) => {
      if (medical_file.base_file.file_category == "指导原则") {
        return '#FF9E00'
      }
      if (medical_file.base_file.file_category == "法规") {
        return '#42BD57'
      }
      if (medical_file.base_file.file_category == "指导原则FDA") {
        return '#39C07A'
      }
      if (medical_file.base_file.file_category == "标准") {
        return '#64AAD6'
      }
      if (medical_file.base_file.file_category == "参考件") {
        return '#666666'
      }
      return '#5F6876'
    },
    borderRadius: '50%',
    color: '#fff',
    fontSize: '18px',
    fontWeight: 'bold',
    textAlign: 'center',
    lineHeight: '38px'
  },
  title: {
    flex: 1,
    fontSize: '18px  !important',
    color: '#4a4a4a',
    fontWeight: 'bold !important',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    cursor: 'pointer'
  },
  fileName: {
    '&:hover': {
      color: '#3276C3'
    }
  },
  fileType: {
    fontSize: '18px  !important',
    color: '#3276C3',
    fontWeight: 'bold !important',
  },
  detailBox: {
    minHeight: '48px',
    marginTop: '8px',
    color: '#4a4a4a',
    fontSize: '14px',
    lineHeight: '20px',
    overflow: 'hidden',    
  },
  detailLine: {
    margin: '7px 0 !important',
  },
  detail: {
    marginRight: '20px !important',
    '& a': {
      color: '#0F55A4',
      cursor: 'pointer',
      fontWeight: 'bold',
    }
  },
  moreDetail: {
    minWidth: '160px',
    marginRight: '40px !important',
    display: 'inline-block'
  },
  btnLine: {
    paddingTop: '12px',
    marginBottom: '14px'
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    borderTop: '1px dashed #D8D8D8',
    '& button': {
      minWidth: '82px',
      height: '32px',
      marginTop: '14px',
      marginLeft: '12px',
      color: '#000',
      '& img': {
        marginRight: '4px'
      },
      '&:hover': {
        border: '1px solid #0F55A4'
      }
    }
  },
  moreInfo: {
    overflow: 'hidden',
    transition: 'height .3s ease-in-out',
    boxSizing: 'border-box',
    '&.show': {
      height: '100px'
    },
    '&.hide': {
      height: 0,
    }
  }
});

export default function FileCard(props) {
  const {  medical_file, handlePreview } = props
  const classes = useStyles(medical_file);

  return (
    <Grid container >
      <Grid item xs={12} className={classes.card}>
        <div className={classes.titleLine}>
          <div className={classes.flexCenter}>
            <Typography className={classes.title} onClick={() => handlePreview(medical_file.dfs_url)}>
              <span className={classes.fileName}>
                {medical_file.file_name.substring(0, medical_file.file_name.length - 4)}
              </span>
              <span className={classes.fileType}>
                {medical_file.file_name.substring(medical_file.file_name.length - 4).toUpperCase()}
              </span>
            </Typography>
          </div>
        </div>

        <div className={classes.detailBox}>
          <Typography className={classes.detailLine}>
            描述：{ medical_file.accumulation_file_description }
          </Typography>
        </div>

        {/* <div className={classes.btnLine}>
          <div className={classes.btnBox}>
            <Button variant="outlined" color="default" onClick={() => handlePreview(medical_file.dfs_url)}>
              <img src={eyeSvg}/>
              预览
            </Button>
          </div>
        </div> */}

        
      </Grid>

     
    </Grid>
  );
}
